// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions
// tslint:disable:no-big-function

import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';

import { squarePanelFromRecommendationsBestPerformingArticles } from './square-panel-best-performing-articles';

export const squarePanelFromRecommendationsBestPerformingArticlesGlobal =
  mergeMultipleConfigs(squarePanelFromRecommendationsBestPerformingArticles, [
    {
      id: 'square-panel-root',
      data: {
        brandOrganisationId: null,
      },
    },
    {
      id: 'brand-org-text',
      if: ['EQ', [false, true]],
    },
  ])[0];
